import * as mutationTypes from './mutationTypes'

export default {
  [mutationTypes.SET_USER_TYPES_AND_FUNCTIONALITIES](state, payload) {
    state.user = payload
  },
}
